<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <modal
      ref="alertDeleteModal"
      modalId="alert-delete-modal"
    >
      <div slot="content">
        <p class="modal-pure-text">
          {{ $t('project.docs.deleteAlert') }}
        </p>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="() => closeAlertModal()"
        >{{ $t('action.no') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          @click="() => deleteFolder()"
        >{{ $t('action.yes') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventBus from '@/utils/eventBus'
import { removeFolder } from '@/api/folders/request'
import Modal from '@/controls/Modal'

export default {
  name: 'DeleteFolder',
  components: {
    Modal,
  },

  beforeDestroyed () {
    if (this.alertDeleteModal) {
      this.alertDeleteModal.destroy()
    }
  },
  computed: {
    ...mapGetters('projects', [
      'currentProject',
    ]),
  },
  methods: {
    ...mapActions('projects', ['loadProject']),
    async init (folderId) {
      if (!this.alertDeleteModal) {
        this.alertDeleteModal = this.$refs.alertDeleteModal
      }
      this.openAlertModal()
      this.folderId = folderId
    },
    openAlertModal () {
      this.alertDeleteModal.open()
    },
    closeAlertModal () {
      this.alertDeleteModal.close()
    },
    async deleteFolder () {
      await removeFolder(this.folderId)
      await this.loadProject(this.currentProject.id)
      EventBus.$emit('modules.projects.documents.folderUpdated')
      this.closeAlertModal()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
</style>
